module.exports = __webpack_public_path__ + "static/media/logo.d5df1ff3.png";